export const clipNumberInput = (value: number | string, min: number, max: number) => {
  if (value === '') return '' as unknown as number;
  return Math.max(min, Math.min(max, Number(value)));
};
